module.exports = __webpack_public_path__ + "img/news2.217d2d9c.png";